import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

export class CantDeterminePositionDialogComponent {
    public modalInstanceService: ng.ui.bootstrap.IModalInstanceService = this as any;
    public resolve: {
        contentTranslateKey: string
    };

    public ok() {
        this.modalInstanceService.close();
    }
}

angular.module('app.common').component('cantDeterminePositionComponent', {
    template: require('./cant-determine-position-dialog.component.html'),
    controller: CantDeterminePositionDialogComponent,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/google-map/cant-determine-position/cant-determine-position-dialog.component.ts